export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.api.safeword.co.uk/api/v1',
  recaptchaSiteKey: '6LfVgr8sAAAAAJ5c1uzfw0EB4WKT2rhPisTouQck',
  socketUrl: 'https://dev.api.safeword.co.uk',
  googleClientId: '391456699404-llndvsrc7avaubqcnivlnrnc3ks4m8fs.apps.googleusercontent.com',
  facebookAppId: '2149990412579927',
};
